import { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { Web3Context } from "../contexts/Web3Context";
import { useAppColors } from "../utils/useAppColors";
import { SubtitleText } from "./SubtitleText";
import { DescriptionText } from "./DescriptionText";
import { SecondaryButton } from "./SecondaryButton";
import { SizedBox } from "./SizedBox";
import { FaEthereum } from "react-icons/fa";
import SolanaIcon from "./SolanaIcon";

function shorten(addr) {
  if (!addr) return "";
  return addr.length > 12 ? addr.slice(0, 6) + "..." + addr.slice(-4) : addr;
}

// Shows the account's linked wallets (Ethereum + Solana). If one is missing,
// offers an Add button that links it to the current account.
export default function WalletsSection() {
  const { user, linkSolana, linkEthereum } = useContext(Web3Context);
  const colors = useAppColors();

  if (!user) {
    return null;
  }

  const ethAddr = user.evmAddress;
  const solAddr = user.solanaAddress;

  return (
    <div>
      <SubtitleText textAlign={"start"} color="black">
        Wallets
      </SubtitleText>
      <DescriptionText textAlign={"start"}>
        Link a wallet on each chain to qualify for that chain's bonds.
      </DescriptionText>
      <SizedBox height={16} />

      <Row className="d-flex align-items-center" style={{ marginBottom: "12px" }}>
        <Col xs={2} className="d-flex align-items-center justify-content-center">
          <FaEthereum size={22} color={colors.primaryColor} />
        </Col>
        <Col className="d-flex align-items-center">
          <DescriptionText textAlign={"start"}>
            {ethAddr ? shorten(ethAddr) : "No Ethereum wallet linked"}
          </DescriptionText>
        </Col>
        <Col xs={"auto"}>
          {!ethAddr && (
            <SecondaryButton text={"Add ETH"} onClick={linkEthereum} />
          )}
        </Col>
      </Row>

      <Row className="d-flex align-items-center" style={{ marginBottom: "12px" }}>
        <Col xs={2} className="d-flex align-items-center justify-content-center">
          <SolanaIcon size={18} color={colors.primaryColor} />
        </Col>
        <Col className="d-flex align-items-center">
          <DescriptionText textAlign={"start"}>
            {solAddr ? shorten(solAddr) : "No Solana wallet linked"}
          </DescriptionText>
        </Col>
        <Col xs={"auto"}>
          {!solAddr && (
            <SecondaryButton text={"Add SOL"} onClick={linkSolana} />
          )}
        </Col>
      </Row>
    </div>
  );
}
